export enum EntityNames {
    User = 'id_user',
    Recipe = 'id_recipe',
    Stage = 'id_stage',
    Compaund = 'id_compaund',
    Product = 'id_product',
    Stat = 'id_kpi',
    CategoryProduct = 'Id_categoryProduct',
    Plans = 'id_plan'
}



// WEBPACK FOOTER //
// ./src/app/shared/dictionaries/EntitiesNames.ts